export const arrayOfDistincObj = <T>(
  array: T[],
  identifier: keyof T,
): T[] => {
  if (!array?.length) return [];
  const result: T[] = [];
  const map = new Map();
  array.forEach((item) => {
    if (!map.has(item[identifier])) {
      map.set(item[identifier], true);
      result.push(item);
    }
  });
  return result;
};
